<template>
    <div style="position: absolute; top: 0; left: 0; color: red; background-color: #fff; z-index: 9999">
        <p>{{ debugMessage }}</p>
    </div>
</template>

<script>
    export default {
        computed: {
            debugMessage() {
                return this.$store.state.debugMessage;
            }
        }
    }
</script>


// WEBPACK FOOTER //
// debug.vue?057c4c52